import { buttonItemSchema, themeButtonDataPartialSchemaLegacy } from '@sites/entity-core';

/**
 * THE partial button entity as the AI button tools accept it — single source of truth shared by
 * `create_button_widget` (each `data.buttons[]` item) and `update_button_widget` (the `data`
 * patch itself), so the two tools' field surface can never drift apart. Lives here rather than in
 * a specific app or the MCP server app — both `apps/mcp-backend`'s mutations and
 * `apps/mcp-server`'s tools need the exact same shape, and neither may import the other (apps
 * depend on packages, never the reverse).
 *
 * `buttonBase` is a DEEP partial (unlike every other nested field, which is a shallow
 * all-or-nothing replace) via entity-core's own `themeButtonDataPartialSchemaLegacy` — both
 * executes have a real "current value" to merge it onto (the default button on create, the
 * stored button on update), so a model that only wants to change the background isn't forced to
 * also resupply border/radius/etc. it never touched.
 */
export const partialButtonItemSchema = buttonItemSchema.partial().extend({
    buttonBase: themeButtonDataPartialSchemaLegacy.optional(),
});
